import { render, staticRenderFns } from "./TransgressesList.vue?vue&type=template&id=17bd48ca&scoped=true&"
import script from "./TransgressesList.vue?vue&type=script&lang=js&"
export * from "./TransgressesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bd48ca",
  null
  
)

export default component.exports